import React, { useEffect, useState } from 'react'
import { Card, Col, Container, Row } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';


export const DisplayStudentData = () => {
    const location = useLocation();
    const data = location.state;
    console.log("data", data.students)


    return (


        <>

            <Container>
                <Row className='mt-3'>
                    {
                        data?.students?.map((student, index) => {
                            return (
                                <>
                                    <Card className='mt-4 shadow p-4' key={index}>
                                        <Row className='m-3 p-4' style={{backgroundColor:"lightgray",borderRadius:"4px",border:"2px solid gray"}}>
                                            <Col>
                                                <Card.Title as="h5">Student Name:{student?.firstname} {student?.lastname}</Card.Title>
                                            </Col>
                                            <Col>
                                                <Card.Title as="h5">Enrollment No: {student?.enrollment}</Card.Title>
                                            </Col>
                                            <Col>
                                                <Card.Title as="h5">Student Email: {student?.email}</Card.Title>
                                            </Col>


                                        </Row>

                                        <Card.Body>
                                            <Card.Title>Grade History</Card.Title>
                                            <Row style={{width:"fit-content",textAlign:"center"}}>
                                                {student?.standards?.map((standard, index) => {
                                                    return (
                                                        <>
                                                            <Row key={index} style={{border:"1px solid gray",margin:"5px"}}>
                                                                <Col >
                                                                    <Card.Text>Standard: {standard?.standard} </Card.Text>
                                                                </Col>
                                                                <Col>
                                                                    <Card.Text>Remarks:{standard?.remarks} </Card.Text>
                                                                </Col>
                                                                <Col>
                                                                    <Card.Text>Percentage:{standard?.percentage} </Card.Text>
                                                                </Col>

                                                            </Row>
                                                        </>
                                                    )
                                                })}
                                            </Row>


                                        </Card.Body>
                                    </Card>
                                </>
                            )
                        })
                    }
                </Row>

            </Container>
        </>
    )
}
